"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.View = exports.Content = exports.ScrollView = exports.Pane = exports.SideBar = exports.LayoutColumn = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./layout.sass");

var LayoutColumn = function LayoutColumn(_ref) {
  var className = _ref.className,
      small = _ref.small,
      half = _ref.half,
      scroll = _ref.scroll,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "small", "half", "scroll"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('layout-column', className, {
      'layout-column--small': small,
      'layout-column--half': half,
      'layout-column--scroll': scroll
    })
  }, props));
};

exports.LayoutColumn = LayoutColumn;
LayoutColumn.propTypes = process.env.NODE_ENV !== "production" ? {
  small: _propTypes.default.bool,
  half: _propTypes.default.bool,
  scroll: _propTypes.default.bool,
  className: _propTypes.default.string
} : {};

var SideBar = function SideBar(_ref2) {
  var className = _ref2.className,
      filled = _ref2.filled,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["className", "filled"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('sidebar', {
      'sidebar--filled': filled
    }, className)
  }, props));
};

exports.SideBar = SideBar;

var Pane = function Pane(_ref3) {
  var className = _ref3.className,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('pane', className)
  }, props));
};

exports.Pane = Pane;

var ScrollView = function ScrollView(_ref4) {
  var className = _ref4.className,
      props = (0, _objectWithoutProperties2.default)(_ref4, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('scroll', className)
  }, props));
};

exports.ScrollView = ScrollView;

var Content = function Content(_ref5) {
  var className = _ref5.className,
      props = (0, _objectWithoutProperties2.default)(_ref5, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('content', className)
  }, props));
};

exports.Content = Content;

var View = function View(_ref6) {
  var className = _ref6.className,
      props = (0, _objectWithoutProperties2.default)(_ref6, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('view', className)
  }, props));
};

exports.View = View;

var Layout =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Layout, _PureComponent);

  function Layout() {
    (0, _classCallCheck2.default)(this, Layout);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Layout).apply(this, arguments));
  }

  (0, _createClass2.default)(Layout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          vertical = _this$props.vertical,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["className", "vertical"]);
      return _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)('layout', className, {
          'layout--vertical': vertical
        })
      }, props));
    }
  }]);
  return Layout;
}(_react.PureComponent);

exports.default = Layout;
Layout.propTypes = process.env.NODE_ENV !== "production" ? {
  vertical: _propTypes.default.bool,
  className: _propTypes.default.string
} : {};